import React from 'react';

const MongoDB_lookup = () => {
  return (
    <div>
      <h1>MongoDB_lookup Component</h1>
      <p>This is the MongoDB_lookup page.</p>
    </div>
  );
};

export default MongoDB_lookup;
